import React from 'react';
import { TargetIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-brand-green px-4 py-24 text-center text-white" data-id="element-59" data-mp="3n4wdgbtdixoq">
      <Reveal className="mx-auto max-w-3xl" data-id="element-60" data-mp="3s2xtsozf0iwi">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-brand-gold" data-id="element-61" data-mp="vlekfi3efj8">
          <TargetIcon className="h-7 w-7" aria-hidden="true" data-id="element-62" data-mp="2zea6knv3vjgb" />
        </div>
        <h2 className="mt-5 text-4xl font-black md:text-5xl" data-id="element-63" data-mp="34cbx1tuv2l1t">
          Klaar om Elk Team Hockeyklaar te Maken?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-64" data-mp="39an8g90t13m5">
          Bespaar je voorbereidingstijd en geef elke training met een duidelijk
          plan, boeiende oefeningen en echt zelfvertrouwen.
        </p>
        <CTAButton className="mt-9 px-10 py-5 text-lg" data-id="element-65" data-mp="2gmr1mbhitvbn">
          BESTEL HET HOCKEY READY-PAKKET
        </CTAButton>
        <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-66" data-mp="2ljzouqhj0pjr">
          Direct toegang · Printklaar · 30 dagen garantie
        </p>
      </Reveal>
    </section>;
}